import { render, staticRenderFns } from "./DealSingleCandidate.vue?vue&type=template&id=0b68a2a6"
import script from "./DealSingleCandidate.vue?vue&type=script&lang=js"
export * from "./DealSingleCandidate.vue?vue&type=script&lang=js"
import style0 from "./DealSingleCandidate.vue?vue&type=style&index=0&id=0b68a2a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports